import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home',     path: '/' },
    { name: 'Services', path: '/#services' },
    { name: 'Solutions',path: '/#solutions' },
    { name: 'Contact',  path: '/#contact' },
  ];

  const handleNavClick = (path, e) => {
    if (path.includes('#')) {
      e?.preventDefault?.();
      const id = path.split('#')[1];
      if (location.pathname === '/') {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.location.href = path;
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Top status strip */}
      <div className="fixed top-0 left-0 right-0 z-[60] bg-ink text-paper text-[11px] font-mono">
        <div className="frame">
          <div className="flex items-center justify-between h-7 tracking-wider uppercase">
            <div className="flex items-center gap-3">
              <span className="status-dot" aria-hidden></span>
              <span>Innovation meets excellence</span>
              <span className="hidden sm:inline text-muted">/</span>
              <span className="hidden sm:inline text-paper-3">200+ companies</span>
            </div>
            <div className="hidden md:flex items-center gap-4">
              <span className="text-paper-3">24/7 support</span>
              <span className="text-paper-3">→</span>
              <a href="mailto:support@charliecollc.com" className="hover:text-lime transition-colors">support@charliecollc.com</a>
            </div>
            <div className="md:hidden flex items-center gap-3">
              <a href="mailto:support@charliecollc.com" className="hover:text-lime transition-colors">support@…</a>
            </div>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav
        className={`fixed top-7 left-0 right-0 z-50 transition-all duration-300 border-b ${
          isScrolled
            ? 'bg-paper/90 backdrop-blur-md border-rule-soft'
            : 'bg-paper/0 border-transparent'
        }`}
      >
        <div className="frame">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="group flex items-center gap-2.5">
              <span aria-hidden className="relative block w-7 h-7 bg-ink">
                <span className="absolute top-1 left-1 right-1 bottom-1 bg-lime"></span>
                <span className="absolute top-0 right-0 w-2 h-2 bg-paper"></span>
              </span>
              <span className="font-display font-semibold text-xl text-ink tracking-tight">
                charliecollc<span className="text-accent">.</span>
              </span>
            </Link>

            {/* Desktop nav */}
            <div className="hidden md:flex items-center gap-7">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.path}
                  onClick={(e) => handleNavClick(link.path, e)}
                  className="link-underline font-mono text-[12px] uppercase tracking-label text-ink hover:text-accent transition-colors"
                >
                  {link.name}
                </a>
              ))}
              <a href="mailto:support@charliecollc.com" className="btn-lime">
                <span>Get Started</span>
                <span aria-hidden>→</span>
              </a>
            </div>

            {/* Mobile button */}
            <button
              onClick={() => setIsMobileMenuOpen((v) => !v)}
              className="md:hidden flex flex-col gap-1.5 p-2 -mr-2"
              aria-label="Toggle menu"
            >
              <span className={`block h-[2px] w-6 bg-ink transition-transform ${isMobileMenuOpen ? 'translate-y-[7px] rotate-45' : ''}`}></span>
              <span className={`block h-[2px] w-6 bg-ink transition-opacity ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-[2px] w-6 bg-ink transition-transform ${isMobileMenuOpen ? '-translate-y-[7px] -rotate-45' : ''}`}></span>
            </button>
          </div>
        </div>

        {/* Mobile drawer */}
        <div
          className={`md:hidden overflow-hidden transition-[max-height] duration-500 ease-out ${
            isMobileMenuOpen ? 'max-h-[420px]' : 'max-h-0'
          } bg-paper border-t border-rule-soft`}
        >
          <div className="frame py-6 space-y-1">
            {navLinks.map((link, i) => (
              <a
                key={link.name}
                href={link.path}
                onClick={(e) => handleNavClick(link.path, e)}
                className="flex items-center justify-between py-3 border-b border-rule-soft"
              >
                <span className="font-display text-xl font-medium">{link.name}</span>
                <span className="label-muted">0{i + 1}</span>
              </a>
            ))}
            <a
              href="mailto:support@charliecollc.com"
              className="btn-lime mt-6 w-full justify-center"
            >
              <span>Get Started</span>
              <span aria-hidden>→</span>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
